<div mat-dialog-title class="dialog-header">
  <h3 class="dialog-title">Rename Department</h3>
  <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
</div>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input autocomplete="off" type="text" matInput formControlName="name" required />
      @if (form.hasError('required', 'name')) {
        <mat-error> Please enter department name. </mat-error>
      }
      @if (form.hasError('noContent', 'name')) {
        <mat-error>Name must contain characters. </mat-error>
      }
      @if (form.hasError('uniqueName', 'name')) {
        <mat-error>Name must be unique. </mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" title="Create" mat-raised-button>Save</button>
  </mat-dialog-actions>
</form>
